class QuantityPicker extends HTMLElement {
  constructor() {
    super();
    this.debounceTimeout = null;
    this.pendingQuantity = null;
  }

  connectedCallback() {
    const [dec, input, inc] = this.querySelectorAll('button, input');

    const update = (step) => {
      const lineItem = this.closest('.line-item');
      const isCart = !!lineItem;

      if (isCart && step < 0 && lineItem.hasAttribute('data-bundle-protected') && Number(input.value) <= 1) {
        window.showBundleProtectedDialog?.();
        return;
      }

      const min = Number(input.min);
      const max = Number(input.max) || 999;
      const moq = Number(input.dataset.minOq || min);

      let val = Number(input.value);

      if (isNaN(val)) {
        val = isCart ? moq : min;
      }

      if (step < 0) {
        if (isCart) {
          if (val <= moq) {
            val = 0;
          } else {
            val -= 1;
          }
        } else {
          val -= 1;
        }
      } else {
        val += 1;
      }

      val = Math.min(max, Math.max(isCart ? 0 : min, val));

      input.value = val;
      this.debouncedSetQuantity(val);
    };

    dec.addEventListener('click', () => update(-1));
    inc.addEventListener('click', () => update(1));

    const selectAll = () => input.select();
    input.addEventListener('focus', selectAll);
    input.addEventListener('click', selectAll);

    input.addEventListener('wheel', (e) => e.preventDefault(), { passive: false });
    input.addEventListener('change', (e) => { e.stopPropagation(); });

    let previousValue = input.value;
    input.addEventListener('focus', () => {
      previousValue = input.value;
    });

    input.addEventListener('blur', () => {
      const lineItem = this.closest('.line-item');
      const isCart = !!lineItem;

      const min = Number(input.min);
      const max = Number(input.max) || 999;
      const moq = Number(input.dataset.minOq || min);

      let val = Number(input.value);

      if (isNaN(val)) {
        val = isCart ? moq : min;
      }

      if (isCart) {
        if (val === 0) {
        } else if (val < moq) {
          val = moq;
        }
      } else {
        val = Math.max(min, val);
      }

      val = Math.min(max, val);

      input.value = val;

      if (val !== Number(previousValue)) {
        clearTimeout(this.debounceTimeout);
        this.pendingQuantity = null;
        this.setQuantity(val);
      }
    });
  }

  debouncedSetQuantity(newQuantity) {
    const lineItem = this.closest('.line-item');

    if (!lineItem) return;

    this.pendingQuantity = newQuantity;

    clearTimeout(this.debounceTimeout);

    this.debounceTimeout = setTimeout(() => {
      this.setQuantity(this.pendingQuantity);
      this.pendingQuantity = null;
    }, 300);
  }

  setQuantity(newQuantity) {
    const input = this.querySelector('input');
    const lineItem = this.closest('.line-item');

    if (!lineItem) return;

    if (lineItem.hasAttribute('data-bundle-protected') && newQuantity < Number(input.value)) {
      input.value = input.value;
      window.showBundleProtectedDialog?.();
      return;
    }

    input.value = newQuantity;

    const lineIndex = Number(this.dataset.line);
    if (!lineIndex) return;

    lineItem.inert = true;

    if (newQuantity === 0) {
      this.deleteLineItem(lineIndex, lineItem);
      return;
    }

    window.changeCartLine(lineIndex, newQuantity)
      .catch((error) => {
        console.error('Error updating cart', error);
        lineItem.inert = false;
      });
  }

  deleteLineItem(lineIndex, lineItem) {
    const startHeight = lineItem.offsetHeight;
    lineItem.style.height = `${startHeight}px`;

    lineItem.getBoundingClientRect();

    lineItem.toggleAttribute('deleting');
    lineItem.style.height = '0px';

    lineItem.addEventListener(
      'transitionend',
      (e) => {
        if (e.target !== lineItem || e.propertyName !== 'height') return;
        lineItem.remove();
      },
      { once: true }
    );

    window.changeCartLine(lineIndex, 0)
      .catch(() => {
        lineItem.inert = false;
      });
  }
}

if (!customElements.get('quantity-picker')) {
  customElements.define('quantity-picker', QuantityPicker);
}
